/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BillingPeriod
 */
export interface BillingPeriod {
    /**
     * 
     * @type {Date}
     * @memberof BillingPeriod
     */
    readonly billing_period_end: Date | null;
}

/**
 * Check if a given object implements the BillingPeriod interface.
 */
export function instanceOfBillingPeriod(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "billing_period_end" in value;

    return isInstance;
}

export function BillingPeriodFromJSON(json: any): BillingPeriod {
    return BillingPeriodFromJSONTyped(json, false);
}

export function BillingPeriodFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingPeriod {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'billing_period_end': (json['billing_period_end'] === null ? null : new Date(json['billing_period_end'])),
    };
}

export function BillingPeriodToJSON(value?: BillingPeriod | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

